// Simple WebSocket client wrapper with auto-reconnect.
// Usage: import { on, off, startRealtime } from './realtime';
// Events fired: telemetry.update, status.update, error.reported

let socket = null;
let listeners = {};
let reconnectAttempts = 0;
let manualClosed = false;

function emit(type, data){
  (listeners[type] || []).forEach(fn => { try { fn(data); } catch(e){ console.error('[realtime listener error]', e); } });
  (listeners['*'] || []).forEach(fn => { try { fn({ type, data }); } catch(e){} });
}

function resolveWsUrl() {
  // Explicit override (e.g. set in index.html before bundle)
  if (window.__SMARTBIN_WS_URL__) return window.__SMARTBIN_WS_URL__;
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = window.location.hostname;
  const port = window.location.port ? `:${window.location.port}` : '';
  return `${proto}//${host}${port}/ws`;
}

function connect(){
  const url = resolveWsUrl();
  socket = new WebSocket(url);
  socket.onopen = () => { reconnectAttempts = 0; emit('realtime.status', { state: 'open' }); };
  socket.onmessage = (ev) => {
    try {
      const msg = JSON.parse(ev.data);
      if (msg && msg.type) emit(msg.type, msg.data);
    } catch(e){ /* ignore */ }
  };
  socket.onclose = () => {
    emit('realtime.status', { state: 'closed' });
    if (manualClosed) return;
    const delay = Math.min(30000, Math.pow(2, reconnectAttempts) * 1000); // 1s,2s,4s,... cap 30s
    reconnectAttempts++;
    setTimeout(connect, delay);
  };
  socket.onerror = () => { /* handled by onclose for reconnection */ };
}

export function startRealtime(){
  manualClosed = false;
  if (!socket || socket.readyState === WebSocket.CLOSED) connect();
}

export function stopRealtime(){
  manualClosed = true;
  if (socket) socket.close();
}

export function on(type, fn){
  if (!listeners[type]) listeners[type] = [];
  listeners[type].push(fn);
  return () => off(type, fn);
}

export function off(type, fn){
  if (!listeners[type]) return;
  listeners[type] = listeners[type].filter(f => f !== fn);
}
